import axios from 'axios';

// export const BASE_URL = 'http://192.168.11.11:1002';
// export const BASE_URL = 'https://airdrive.nvpworld.com';
export const BASE_URL = 'https://airdrive.co.kr';

export const axiosConfigInstance = (path: string,token?:string,type?:any) => axios.create({
    // baseURL: `https://theme.nvpworld.com${path}`,
    baseURL: `${BASE_URL}${path}`,
    timeout: 50000,
    headers: {
        'authorization':token,
        ...type
    }
});


// "homepage": "https://music.subox.co.kr/platform",

export const KAKAO_LINK = 'https://pf.kakao.com/_rxowhs';
export const PHONE = '1833-4421';